import React from "react";
import { Link, useNavigate, Outlet } from "react-router-dom";
import LogoutButtonNew from "./LogoutButtonNew";


function HeaderResearcher(props) {
    return (
        <>
            <header>
                <nav className="navbar navbar-expand-md navbar-dark bg-black-color bottom-outline-gray text-gray">
                    <div className="container-fluid researcher-header-margin">
                        <Link to={{ pathname: "/dashboard" }} className="navbar-brand mr-3 py-2">
                            <strong className="logo-text">
                                de<span className="logo-span-highlight-new">spark</span>
                            </strong>
                        </Link>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                            id="toggleMobileNav" aria-controls="navbarSupportedContent" aria-expanded="false"
                            aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse navbar-mobile" id="navbarSupportedContent">
                            <ul className="navbar-nav me-auto">
                                <li className="nav-item mx-3">
                                    <Link to={{ pathname: "/dashboard" }} className="nav-link mobile-nav-link text-gray">
                                        Dashboard
                                    </Link>
                                </li>
                            </ul>
                            <ul className="navbar-nav ms-auto nav-link mobile-nav-link ">
                                <li>
                                    <LogoutButtonNew />
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>

            </header>
            <Outlet />
        </>
    )
}

export default HeaderResearcher;